import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'

export const AlertDialogEnrollUser = ({ eventId, participants, onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [selected, setSelected] = useState(null)
  const [loading, setLoading] = useState(false)
  const [enrolling, setEnrolling] = useState(false)
  const inputRef = useRef(null)
  const debounceRef = useRef(null)

  // Limpia resultados al abrir; el teclado se abre via autoFocus en el input
  useEffect(() => {
    if (isOpen) setResults([])
  }, [isOpen])

  // Búsqueda con debounce contra el nuevo endpoint
  useEffect(() => {
    clearTimeout(debounceRef.current)
    if (!query.trim()) {
      setResults([])
      return
    }
    debounceRef.current = setTimeout(async () => {
      setLoading(true)
      try {
        const participantIds = new Set(participants.map(p => p.id))
        const res = await axios.get(
          `${constants.urlLocal}searchUsers?q=${encodeURIComponent(query.trim())}`
        )
        const users = (res.data.users || []).filter(
          u => !participantIds.has(u._id)
        )
        setResults(users)
      } catch {
        setResults([])
      } finally {
        setLoading(false)
      }
    }, 300)
    return () => clearTimeout(debounceRef.current)
  }, [query, participants])

  const handleEnroll = async () => {
    if (!selected) return
    setEnrolling(true)
    try {
      await axios.post(`${constants.urlLocal}inscription/create`, {
        userId: selected._id,
        eventId,
      })
      onSuccess()
      handleClose()
    } catch {
      // no-op
    } finally {
      setEnrolling(false)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
    setQuery('')
    setSelected(null)
    setResults([])
  }

  return (
    <>
      <button className="enroll-admin-btn" onClick={() => setIsOpen(true)}>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="8.5" cy="7" r="4" />
          <line x1="20" y1="8" x2="20" y2="14" />
          <line x1="23" y1="11" x2="17" y2="11" />
        </svg>
        Apuntar persona
      </button>

      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title="Apuntar participante"
        size="sm"
      >
        {/* Buscador */}
        <div className="enroll-search">
          <svg
            className="enroll-search__icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            ref={inputRef}
            className="enroll-search__input"
            type="text"
            placeholder="Buscar por nombre..."
            value={query}
            autoFocus
            onChange={e => {
              setQuery(e.target.value)
              setSelected(null)
            }}
          />
          {query && (
            <button
              className="enroll-search__clear"
              onClick={() => {
                setQuery('')
                setSelected(null)
              }}
            >
              ✕
            </button>
          )}
        </div>

        {/* Lista */}
        <div className="enroll-list">
          {loading ? (
            <div className="enroll-list__loading">Buscando...</div>
          ) : !query.trim() ? (
            <div className="enroll-list__empty">Escribe para buscar</div>
          ) : results.length === 0 ? (
            <div className="enroll-list__empty">Sin resultados</div>
          ) : (
            results.map(u => (
              <button
                key={u._id}
                className={`enroll-list__item${selected?._id === u._id ? ' enroll-list__item--selected' : ''}${!u.hasPaid ? ' enroll-list__item--unpaid' : ''}`}
                onClick={() => setSelected(u)}
              >
                <div className="enroll-list__avatar">
                  {u.avatar ? (
                    <img src={u.avatar} alt={u.name} />
                  ) : (
                    <span>
                      {u.name?.[0]}
                      {u.lastname?.[0]}
                    </span>
                  )}
                </div>
                <div className="enroll-list__info">
                  <span className="enroll-list__name">
                    {u.name} {u.lastname}
                  </span>
                  {!u.hasPaid && (
                    <span className="enroll-list__badge">Sin pago</span>
                  )}
                </div>
                {selected?._id === u._id && (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
            ))
          )}
        </div>

        {/* Footer */}
        <div className="enroll-footer">
          <Button variant="ghost" onClick={handleClose} disabled={enrolling}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleEnroll}
            disabled={!selected || enrolling}
          >
            {enrolling
              ? 'Apuntando...'
              : selected
                ? `Apuntar a ${selected.name}`
                : 'Selecciona alguien'}
          </Button>
        </div>
      </Modal>
    </>
  )
}
